import { useEffect } from 'react';
import { Dialog, DialogContent, DialogTitle, DialogActions, FlexGrid, Typography, Button } from "@albo-ui/core";
import { MenuItem, Select, FormControl, InputLabel, TextField, FormControlLabel, Checkbox, FormLabel } from "@mui/material";
import { useManageSeller } from './hooks/useManageSeller';
import { sellerRole, sellerType } from '../../../util/DataObject';
import { ManageSellerProps } from './types';
import InfoIcon from '@mui/icons-material/Info';


export const ManageSeller = ({ item, open, changeLoader, changeAlert, onClose, onConfirm }: ManageSellerProps) => {
    const { zPos, form, error, isValid, agentList, onHandleSave, onHandleChange, onHandleFindAgent } = useManageSeller(changeLoader, changeAlert, open);

    useEffect(() => {
        open && item && onHandleSave(item);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);

    return (
        <Dialog onClose={onClose} open={open} style={{minWidth: 600, maxHeight: 500, visibility: zPos !== 45 ? "hidden" : "visible"}}>
            <DialogTitle>
                <Typography variant='h2'>{item ? "Editar vendedor" : "Crear vendedor"}</Typography>
            </DialogTitle>

            <DialogContent>
            {!item && <FlexGrid container spacing={2} style={{ display: "grid"}} fullWidth>
                <FlexGrid item><InfoIcon fontSize='small' color='primary' sx={{ mr: 0.5, verticalAlign: "sub" }}/><Typography variant='small' color='primary'>Selecciona el rol del vendedor.</Typography></FlexGrid>
                    <FlexGrid item container spacing={2} fullWidth>
                        <FormControl variant="outlined" sx={{width: "50%"}} >
                            <InputLabel>Rol</InputLabel>
                            <Select label={"Rol"} value={(form && form["role"]) || -1} onChange={onHandleChange.bind(this, "role", "")} color="secondary" MenuProps={{style: {zIndex: 35001}}} sx={{mb: 2}} fullWidth variant="outlined">
                                <MenuItem value={-1} disabled>Seleccione</MenuItem>
                                { sellerRole.map((item, index) => {
                                        return <MenuItem value={item.key} key={`item-rol-${index}`}>{item.label}</MenuItem>
                                    })}
                            </Select>
                        </FormControl>
                        {agentList.length > 0 && form && form["role"] === "agent" &&
                            <FormControl variant="outlined" sx={{width: "50%"}} >
                                <InputLabel>Agentes</InputLabel>
                                <Select label={"Agentes"} value={(form && form["uuid"]) || -1} onChange={onHandleFindAgent.bind(this)} color="secondary" MenuProps={{style: {zIndex: 35001}}} sx={{mb: 2}} fullWidth variant="outlined">
                                    <MenuItem value={-1} disabled>Seleccione</MenuItem>
                                    { agentList.map((item, index) => {
                                            return <MenuItem value={item.uuid} key={`agent-${index}`}>{item.name}</MenuItem>
                                        })}
                                </Select>
                            </FormControl>
                        }
                    </FlexGrid>
                </FlexGrid>
            }
            {form && form["role"] && 
                <FormControl component="fieldset" variant="standard" fullWidth>
                    <FormLabel component="legend">Tipo de {form["role"] === "agent" ? "Agente" : "Promotor"}</FormLabel>
                    <FlexGrid container spacing={2}>
                    {sellerType.map((item, index) => {
                        return item.role === form["role"] && <FlexGrid item key={`type-${index}`}>
                        <FormControlLabel
                            control={
                                <Checkbox checked={form["type"] === item.key} onChange={onHandleChange.bind(this, "type", "")} name={item.key} />
                            } label={item.label}
                            />
                        </FlexGrid>
                    })}
                    </FlexGrid>
                </FormControl>
            }

            {form && (form["role"] === "promoter" || form["uuid"]) && <FlexGrid container spacing={2} style={{marginTop: 30, display: "grid"}} fullWidth>
                <FlexGrid item container spacing={2} fullWidth>
                    <TextField
                        label="Nombre(s)"
                        value={(form["general"] && form["general"]["gname"]) || ""}
                        onChange={onHandleChange.bind(this, "general", "gname")}
                        error={error && error["gname"] ? true : false} helperText={error && error["gname"]} fullWidth
                    />
                    <TextField
                        label="Apellido paterno"
                        value={(form["general"] && form["general"]["fname"]) || ""}
                        onChange={onHandleChange.bind(this, "general", "fname")}
                        error={error && error["fname"] ? true : false} helperText={error && error["fname"]} fullWidth
                    />
                </FlexGrid>
                <FlexGrid item container spacing={2} fullWidth>
                    <TextField
                        label="Apellido materno"
                        value={(form["general"] && form["general"]["sfname"]) || ""}
                        onChange={onHandleChange.bind(this, "general", "sfname")}
                        fullWidth
                    />
                    <TextField
                        label="Correo electrónico"
                        value={(form["general"] && form["general"]["email"]) || ""}
                        onChange={onHandleChange.bind(this, "general", "email")}
                        error={error && error["email"] ? true : false} helperText={error && error["email"]} fullWidth
                    />
                </FlexGrid>
                <FlexGrid item container spacing={2} fullWidth>
                    <TextField
                        label="RFC"
                        value={(form["general"] && form["general"]["taxid"]) || ""}
                        onChange={onHandleChange.bind(this, "general", "taxid")}
                        error={error && error["taxid"] ? true : false} helperText={error && error["taxid"]} fullWidth
                    />
                    <TextField
                        label="Teléfono"
                        value={(form["general"] && form["general"]["phone"]) || ""}
                        onChange={onHandleChange.bind(this, "general", "phone")}
                        error={error && error["phone"] ? true : false} helperText={error && error["phone"]} fullWidth
                    />
                </FlexGrid>
                {form["role"] === "promoter" &&<FlexGrid item container spacing={2} fullWidth>
                    <TextField
                        label="CLABE albo"
                        value={(form["general"] && form["general"]["clabe"]) || ""}
                        onChange={onHandleChange.bind(this, "general", "clabe")}
                        error={error && error["clabe"] ? true : false} helperText={error && error["clabe"]} fullWidth
                    />
                </FlexGrid>}
            </FlexGrid>
            }
            </DialogContent>

            <DialogActions>
                <FlexGrid container fullHeight fullWidth justify="space-between" alignItems="flex-end" style={{ marginTop: 10 }}>
                    <FlexGrid item>
                        <Button onClick={onClose} buttonType="secondary" size="normal">Cancelar</Button>
                    </FlexGrid>
                    <FlexGrid item>
                        <Button onClick={onConfirm.bind(this, form)} disabled={isValid} size="normal" >Aceptar</Button>
                    </FlexGrid>
                </FlexGrid>
            </DialogActions>
        </Dialog>
    );
};
